import React, {useState, useEffect} from 'react';
import {FormControl, FormSelect} from "react-bootstrap";
import {useStores} from "../../../stores/Context";
import {observer} from "mobx-react";
import {getAllSapsQueryByTotemID, getSaspQueryCOlumnNameById} from "../../../utils/requests";
import axios from "axios";
import stylesModule from "../../Widgets/WidgetIndicateur/WidgetIndicateurNiveaux.module.scss";

// Observer pour le composant CreateObjectTableau
const CreateObjectTableau = observer(({idObjet, data}) => {
    // Utilisation des stores
    const {niveauxIndicateurStore: NIS, widgetStore} = useStores();
    const idTotem = widgetStore.idTotem;

    // Utilisation de useState pour gérer l'état local du composant
    const [dataTable, setDataTable] = useState(data);
    const [dataColonnes, setDataColonnes] = useState([]);
    const [sourcesAvailable, setSourcesAvailable] = useState([]);
    const [sourcesManuelle, setSourcesManuelle] = useState([]);
    const getKeyWithValueCookie = () => {
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            let keyAndValue = c.split('=');
            if (keyAndValue[1] === widgetStore._token){
                return keyAndValue[0].replace("_apiToken", "");
            }
        }
        return null;
    }
    const ent = getKeyWithValueCookie()

    console.log('Table__Logs', [
        sourcesAvailable,
        sourcesManuelle,
    ]);
    // Utilisation de useEffect pour effectuer des effets secondaires dans le composant
    useEffect(() => {
        const fetchData = async () => {
            setSourcesAvailable(await getAllSapsQueryByTotemID(idTotem, ent));

            // const sources = await axios.get(process.env.REACT_APP_API_URL + '/api/saisie/list/' + ent,
            const sources = await axios.get(process.env.REACT_APP_API_URL + '/api/saisie/list/' + ent,
                {headers: {"Authorization": `Bearer ${widgetStore._token}`}}
            );
            setSourcesManuelle(sources.data);
        }
        fetchData();
    }, []);

    // Autre useEffect pour gérer d'autres effets secondaires
    useEffect(() => {
        const fetchColumns = async () => {
            if (NIS.objetTableauValue.tab_id_requete_sasp !== '0') {
                // check if 'tab_id_requete_sasp' is a YDOS source or a manual source
                const isYdos = sourcesAvailable.find((source) => source.id === NIS.objetTableauValue.tab_id_requete_sasp);
                if (isYdos) {
                    const columns = await getSaspQueryCOlumnNameById(NIS.objetTableauValue.tab_id_requete_sasp, ent);
                    setDataColonnes(columns);
                } else {
                    setDataColonnes(['valeur_saisie', 'date_saisie']);
                }
            } else {
                setDataColonnes([]);
            }
        }
        fetchColumns();
    }, [NIS.objetTableauValue.tab_id_requete_sasp, sourcesAvailable, sourcesManuelle])

    // Fonctions pour gérer les événements de l'interface utilisateur
    const handleAddColonne = () => {
        NIS.objetTableauValue.colonne.push({
            col_nom_affiche: "",
            col_nom_sasp: "",
            obj_elem_id: ""
        });
    }

    const handleChangeColSource = (e, i) => {
        NIS.objetTableauValue.colonne[i].col_nom_sasp = e.target.value;
        dataTable.colonne[i].col_nom_sasp = NIS.objetTableauValue.colonne[i].col_nom_sasp;
    }

    const handleChangeColName = (e, i) => {
        NIS.objetTableauValue.colonne[i].col_nom_affiche = e.target.value;
        dataTable.colonne[i].col_nom_affiche = NIS.objetTableauValue.colonne[i].col_nom_affiche;
    }

    const handleDeleteColonne = (i) => {
        if (NIS.objetTableauValue.colonne.length > 1) {
            NIS.objetTableauValue.colonne.splice(i, 1);
            dataTable.colonne = NIS.objetTableauValue.colonne;
        }
    }

    const styles = {
        label: {
            color: 'var(--SEIZO-dark, #002335)',
            fontFamily: '"Sofia Pro", serif',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '130%',
            float: 'left',
            marginBottom: '.5em',
        },
        input: {
            display: 'inline-flex',
            padding: '12px 18px',
            marginBottom: '1em',
            alignItems: 'flex-start',
            gap: '18px',
            borderRadius: '4px',
            border: '1px solid var(--icon-black, #002335)',
            backgroundColor: 'var(--icon-light-BG, #FBFDFE)',
            /* font styles */
            color: 'var(--icon-black, #002335)',
            fontFamily: 'Nunito, serif',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '130%',
        },
        addObjectButton: {
            zIndex: 999,

            display: 'flex',
            width: '30px',
            height: '30px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '12px',

            borderRadius: '60px 60px 60px 4px',
            background: 'var(--icon-accent, #00B0FF)',
            cursor: 'pointer'
        }
    }

    // Rendu du composant
    return (
        <div className={"CreateObjectTableau_content"}>
            <p style={styles.label}>Titre du tableau</p>
            <FormControl style={styles.input} type={"input"} value={NIS.objetTableauValue.tab_nom} onChange={
                (e) => {
                    NIS.objetTableauValue.tab_nom = e.target.value;
                    dataTable.tab_nom = NIS.objetTableauValue.tab_nom;
                }}/>


            <p style={styles.label}>Source de données</p>
            <FormSelect value={dataTable.tab_id_requete_sasp} className={""}
                        style={styles.input}
                        onChange={
                            (e) => {
                                NIS.objetTableauValue.tab_id_requete_sasp = e.target.value;
                                dataTable.tab_id_requete_sasp = NIS.objetTableauValue.tab_id_requete_sasp;
                                // if e.target.value is in soucesManuelle, set obj_source_type to 'Manuelle'
                                const isManuelle = sourcesManuelle.find((source) => source.id_widget === e.target.value);
                                if (isManuelle) {
                                    NIS.objetTableauValue.obj_source_type = 'Manuelle';
                                } else {
                                    NIS.objetTableauValue.obj_source_type = 'YDOS';
                                }
                            }}>
                <option value={'0'}>Choisir la source de données</option>
                <optgroup style={{fontWeight: 'bold', fontStyle: 'italic'}} label={"Saisies manuelles"}/>
                {
                    sourcesManuelle.length === 0 ? (
                            <option value={0} disabled={true}>Aucune source manuelle disponible</option>) :
                        sourcesManuelle.map((data) => (
                            <option value={data?.id_widget}>{data?.nom_list_saisie}</option>
                        ))
                }
                <optgroup style={{fontWeight: 'bold', fontStyle: 'italic'}} label={"YDOS"}/>
                {
                    sourcesAvailable.length === 0 ? (
                            <option value={0} disabled={true}>Aucune source YDOS disponible</option>) :
                        sourcesAvailable.map((source) => (
                            <option value={source.id}>{source.nom}</option>
                        ))
                }
            </FormSelect>
            {
                NIS.objetTableauValue.tab_id_requete_sasp !== '0' && (
                    <div>
                        <p className={'subTitle__objElem_tableau mt-4'}>
                            Colonnes
                            <div className="float-right">

                                <div style={styles.addObjectButton} onClick={handleAddColonne}
                                     onTouchEnd={handleAddColonne}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                         fill="none">
                                        <path d="M10.5215 2.5V17.5007" stroke="white" strokeWidth="2"/>
                                        <path d="M3.02148 10L18.0215 10" stroke="white" strokeWidth="2"/>
                                    </svg>
                                </div>
                                {/*<FontAwesomeIcon className={"CreateObjectTableau_AddColonne"} icon={faPlusCircle}*/}
                                {/*                 onClick={handleAddColonne}/>*/}
                            </div>
                        </p>
                        {
                            NIS.objetTableauValue.colonne.map((col, i) => (
                                <div className={"CreateObjectTableau_DataColonne"}>
                                    {/*<FontAwesomeIcon className={"CreateObjectTableau_DeleteColonne"}*/}
                                    {/*                 icon={faMinusCircle} onClick={() => handleDeleteColonne(i)}/>*/}
                                    <FormControl id={"Tab_NomCol_" + i} value={col.col_nom_affiche}
                                                 className={`ml-2 ${stylesModule.tableauForm__formInput} CreateObjectTableau_NameAffichage` + i}
                                                 placeholder={"Nom colonne"} onChange={(e) => {
                                        handleChangeColName(e, i)
                                    }}/>
                                    <FormSelect value={col.col_nom_sasp} id={"Tab_DataCol_" + i}
                                                className={`ml-2 ${stylesModule.tableauForm__formInput} tableauForm__formInput CreateObjectTableau_DataAffichage_` + i}
                                                onChange={(e) => handleChangeColSource(e, i)}>
                                        <option>Choisir une donnée</option>
                                        {
                                            dataColonnes.map((data) => (
                                                <option value={data}>{data}</option>
                                            ))
                                        }
                                    </FormSelect>
                                    <div onClick={() => handleDeleteColonne(i)} className={'mx-2'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21"
                                             viewBox="0 0 20 21" fill="none">
                                            <path
                                                d="M3.30809 16.6505L2.71726 4.83398H17.2814L16.6906 16.6505C16.6108 18.2471 15.293 19.5007 13.6944 19.5007H6.30435C4.70572 19.5007 3.38792 18.2471 3.30809 16.6505Z"
                                                stroke="#F82121" strokeWidth="2"/>
                                            <path
                                                d="M6.83398 4.5H13.1673V3.5C13.1673 2.39543 12.2719 1.5 11.1673 1.5H8.83399C7.72942 1.5 6.83398 2.39543 6.83398 3.5V4.5Z"
                                                stroke="#F82121" strokeWidth="2"/>
                                            <path d="M0.833984 4.66602H19.1673" stroke="#F82121" strokeWidth="2"/>
                                            <path d="M12.5 9.66602V13.8327" stroke="#F82121" strokeWidth="2"/>
                                            <path d="M7.5 9.66602V13.8327" stroke="#F82121" strokeWidth="2"/>
                                        </svg>
                                    </div>
                                </div>
                            ))
                        }
                        {/*<FontAwesomeIcon className={"CreateObjectTableau_AddColonne"} icon={faPlusCircle} onClick={handleAddColonne}  />*/}
                    </div>
                )
            }
        </div>
    );
});

export default CreateObjectTableau;